import React, { useState } from 'react';
import { Icon } from '@shakkerai/components';
import { setTempState } from '@starflow/app/store';
import { translate } from '@shakkerai/util-i18n';
import { isOverseas } from '@shakkerai/pro-utils';
// import { GuidePopover } from '@shakkerai/pro-components';
import { HoverCard, Popover } from '@mantine/core';
import tutorIcon from './assets/tutor-icon.svg';
import guideIcon from './assets/guide-icon.svg';
import iconDiscord from './assets/icon_discord.svg';
import wxGroup from './assets/wx-goup-0116.jpeg';
import iconWX from './assets/message.svg';
import './navbar.scss';

export const Guides = React.memo(() => {
  // const firstGeneratedDoneFlag = useTempState('firstGeneratedDoneFlag');
  const [opened, setOpened] = useState(false);

  return (
    <>
      <HoverCard width={120} shadow="md">
        <HoverCard.Target>
          <button>
            <Icon className="shk-bangzhu mx-[5px]" color="#fff" fontSize={16} id="helpButtonEntry"></Icon>
          </button>
        </HoverCard.Target>
        <HoverCard.Dropdown>
          <div className="help-wrapper -mx-3">
            {isOverseas ? (
              <div className="flex items-center py-2 px-3 hover:bg-[#F4F6F8] rounded-sm">
                <button
                  onClick={() => {
                    window.open('https://discord.gg/djyP5u3vHY');
                    mc('tutorial');
                  }}
                  className="flex items-center"
                >
                  <img src={iconDiscord} className="w-4 h-4" alt="" />
                  <span className="text-[12px] ml-2">Help</span>
                </button>
              </div>
            ) : (
              <Popover
                position="right"
                opened={opened}
                onMouseEnter={() => setOpened(true)}
                onMouseLeave={() => setOpened(false)}
              >
                <Popover.Target>
                  <div className="flex items-center py-2 px-3 hover:bg-[#F4F6F8] rounded-sm">
                    <button className="flex items-center">
                      <img src={iconWX} className="w-4 h-4" alt="" />
                      <span className="text-[12px] ml-2">交流群</span>
                    </button>
                  </div>
                </Popover.Target>
                <Popover.Dropdown className="p-0 rounded-[2px] overflow-hidden border-none shadow-lg">
                  <div className="flex flex-col items-center justify-center w-[200px] py-4 bg-white border-t-2 border-primary">
                    <span className="text-sm font-medium text-[#383838]">微信群</span>
                    <img src={wxGroup} className="w-[100px] h-[100px] mt-1" alt="" />
                    <span className="mt-3 text-xs text-[#7a7a7a]">扫码加入， 一起探索模型搭配</span>
                  </div>
                </Popover.Dropdown>
              </Popover>
            )}

            <div
              className="flex text-[#2D2D2D] cursor-pointer py-2 px-3 hover:bg-[#F4F6F8] rounded-sm"
              onClick={() => {
                if (isOverseas) {
                  window.open(
                    'https://docs.google.com/document/d/1jJR-HNm8vS36d4gd7H7q2U8x9FuX3bKC63hiDq5Lk0U/edit?tab=t.0#heading=h.o59cmgdxkbtq',
                  );
                } else {
                  window.open('https://liblibai.feishu.cn/wiki/VQN7w4SSOi1dvpkkqLmcd6O4nZM');
                }
              }}
            >
              <img src={tutorIcon} className="w-4 h-4" />
              <span className="text-[12px] ml-2">{translate('tutorials')}</span>
            </div>
            <div
              className="flex text-[#2D2D2D] cursor-pointer py-2 px-3 hover:bg-[#F4F6F8] rounded-sm"
              onClick={() => setTempState({ newerGuideTipOpen: true })}
            >
              <img src={guideIcon} className="w-4 h-4" />
              <span className="text-[12px] ml-2">{translate('common_Guidance')}</span>
              {/* <GuidePopover
                visible={firstGeneratedDoneFlag}
                title={translate('guideTip_finish_title')}
                position="bottom"
                width={280}
                showFooter={false}
                offset={{ mainAxis: 20, crossAxis: 40 }}
                content={
                  <span className="flex items-center">
                    {translate('guideTip_finish_desc_1')}
                    <Icon className="icon-problem" fontSize={20} color="inherit" />
                    {translate('guideTip_finish_desc_2')}
                  </span>
                }
                onClose={() => {
                  setTempState({ firstGeneratedDoneFlag: false });
                }}
              /> */}
            </div>
          </div>
        </HoverCard.Dropdown>
      </HoverCard>
      {/* <div
        className={styles.tutorials}
        onClick={() => {
          if (isOverseas) {
            window.open('https://docs.google.com/document/d/1jJR-HNm8vS36d4gd7H7q2U8x9FuX3bKC63hiDq5Lk0U/edit?tab=t.0#heading=h.o59cmgdxkbtq');
          } else {
            window.open('https://liblibai.feishu.cn/wiki/VQN7w4SSOi1dvpkkqLmcd6O4nZM');
          }
        }}
      >
        <Icon className="shk-dingbar-Tutorials" color="inherit"></Icon>
        <span className="font-semibold">{translate('tutorials')}</span>
      </div>
      <div id="helpButtonEntry" className={styles.tutorials} onClick={() => setTempState({ newerGuideTipOpen: true })}>
        <Icon className="icon-problem" fontSize={20} color="inherit" />
        <GuidePopover
          visible={firstGeneratedDoneFlag}
          title={translate('guideTip_finish_title')}
          position="bottom"
          width={280}
          showFooter={false}
          offset={{ mainAxis: 20, crossAxis: 40 }}
          content={
            <span className="flex items-center">
              {translate('guideTip_finish_desc_1')}
              <Icon className="icon-problem" fontSize={20} color="inherit" />
              {translate('guideTip_finish_desc_2')}
            </span>
          }
          onClose={() => {
            setTempState({ firstGeneratedDoneFlag: false });
          }}
        />
      </div> */}
    </>
  );
});
